export default {
  addButton: "Add",
  bundleAddOnsStepText1:
    "Choose three sites in the Rivals network to add to your bundle.",
  bundleAddOnsStepTitle: "Bundle & Save",
  cancelButton: "Cancel",
  nextButton: "Next",
  noResults: "No results were found",
  removeButton: "Remove",
  searchAnotherSchool: "Search to add another school",
  searchForYourRivals: "Search for your rivals"
};
